// ** React Imports
import React, { useState, Fragment, useEffect } from 'react'
// import AccessPermission from '../Pages/Permission'
import AccessPermission from './Permission'
import RoleManagement from './RolesManangement/RoleMaagement'

const MainRoleManagement = () => {
    const [menuAccess, setMenuAccess] = useState('')
    const [editable, setEditable] = useState(true)

    // useEffect(() => {
    //     if (localStorage.getItem('allMenuData')) {
    //         const allMenuData = JSON.parse(localStorage.getItem('allMenuData'))
    //         if (allMenuData) {
    //             const findCurrency = allMenuData.find(find => find.menuId === 5 && find.show)
    //             if (findCurrency) {
    //                 setMenuAccess('AccessOk')
    //                 setEditable(findCurrency.editable)
    //             } else {
    //                 setMenuAccess('AccessNotOk')
    //             }
    //         }
    //     }
    // }, [localStorage.getItem('allMenuData')])

    return (
        <Fragment>
            {/* {menuAccess === 'AccessOk' && */}
            <RoleManagement editable={editable} />
            {/* } */}
            {/* {menuAccess === 'AccessNotOk' &&
                <AccessPermission />
            } */}
        </Fragment>
    )
}

export default MainRoleManagement
